import GoogleIcon from "@/assets/icons/google.svg";
import Button, { ButtonProps } from "@components/Button";

import styles from "./GoogleButton.module.css";

const GoogleButton = (props: ButtonProps) => {
  return (
    <Button
      block
      className={styles.root}
      icon={GoogleIcon}
      variant="secondary"
      {...props}
    />
  );
};

export default GoogleButton;
